function helpArticle(name) {
    return "https://help.sayanchor.com/en/articles/".concat(name);
}
function intercomHelpArticle(name) {
    return "https://intercom.help/anchor-billing/en/articles/".concat(name);
}
export const helpArticles = {
    howToEditAgreement: ()=>helpArticle('5095234-how-to-edit-an-agreement'),
    chargebacksAndDisputes: (goto)=>{
        const suffix = goto === 'missing-auth' ? '#h_6c2de571af' : '';
        return helpArticle("8304718-chargebacks-and-payment-disputes-in-anchor".concat(suffix));
    },
    qboSetup: (goto)=>{
        const suffix = goto === 'services-mapping' ? '#h_cae7f37e1c' : goto === 'contact-mapping' ? '#h_1492f2224f' : '';
        return helpArticle("6745076-setting-up-quickbooks-online".concat(suffix));
    },
    qboReactivateItems: ()=>helpArticle('8385713-how-to-reactivate-items-in-quickbooks-online'),
    qboUnlinkPayment: ()=>helpArticle('8544439-how-to-unlink-a-payment-from-a-deposit-in-quickbooks-online'),
    qboAccountPeriodClosed: ()=>helpArticle('8676191-how-to-resolve-a-quickbooks-online-sync-error-for-a-closed-account-period'),
    qboChangeInvoicePrefix: ()=>helpArticle('11640349-changing-invoice-prefix'),
    onboardingExistingClients: ()=>helpArticle('10219710-best-practices-for-onboarding-existing-clients-to-anchor'),
    amendmentsRequiringApproval: ()=>helpArticle('7733302-what-amendments-must-the-client-approve'),
    refunds: ()=>helpArticle('8011138-refunding-client-payments'),
    achUnauthorizedFailures: ()=>helpArticle('6668991-can-i-minimize-the-potential-for-disputes-and-declined-payments-due-to-unauthorization-failures-ach'),
    referralProgram: ()=>helpArticle('8102891-what-is-anchor-s-referral-program'),
    proposalTemplates: ()=>helpArticle('8512622-proposal-templates'),
    notificationSettings: ()=>helpArticle('9729494-notification-settings'),
    requestPaymentMethod: ()=>helpArticle('8344568-about-request-payment-method'),
    anchorZaps: ()=>helpArticle('7833601-what-anchor-zaps-can-i-create'),
    microsoftTeamsZapier: ()=>helpArticle('16430861-how-to-connect-anchor-to-microsoft-teams-using-zapier-beta'),
    googleChatZapier: ()=>helpArticle('16579577-how-to-connect-anchor-to-google-chat-using-zapier-beta'),
    typeformZapier: ()=>helpArticle('15994986-how-to-connect-anchor-to-typeform-using-zapier-beta'),
    surveyMonkeyZapier: ()=>helpArticle('15995517-how-to-connect-anchor-to-surveymonkey-using-zapier-beta'),
    googleFormsZapier: ()=>helpArticle('15995337-how-to-connect-anchor-to-google-forms-using-zapier-beta'),
    clickUpZapier: ()=>helpArticle('16087977-how-to-connect-anchor-to-clickup-using-zapier-beta'),
    notionZapier: ()=>helpArticle('16287891-how-to-connect-anchor-to-notion-using-zapier-beta'),
    taxDomeZapier: ()=>helpArticle('15996124-how-to-connect-anchor-to-taxdome-using-zapier-beta'),
    calendlyZapier: ()=>helpArticle('16086805-how-to-connect-anchor-to-calendly-using-zapier-beta'),
    zohoCrmZapier: ()=>helpArticle('16087424-how-to-connect-anchor-to-zoho-crm-using-zapier-beta'),
    karbon: ()=>helpArticle('9881648-karbon'),
    clientHub: ()=>helpArticle('9920686-client-hub'),
    financialCents: ()=>helpArticle('9881503-financial-cents'),
    keeper: ()=>helpArticle('11193603-double'),
    kybProcessOverview: ()=>intercomHelpArticle('9938694-kyb-process-overview'),
    paymentsViaAnchor: ()=>intercomHelpArticle('5661179-payments-via-anchor'),
    kFormIssuance2024: ()=>intercomHelpArticle('12525562-1099-k-form-issuance-2025'),
    importClientsBulk: ()=>intercomHelpArticle('4848558-how-to-import-clients-in-bulk-using-a-csv-file'),
    connectQuickbooksAnchor: ()=>intercomHelpArticle('6867639-how-to-connect-quickbooks-to-anchor'),
    applyClientCredit: ()=>intercomHelpArticle('6118071-how-to-apply-a-credit-for-your-client'),
    xeroSetup: ()=>helpArticle("11624549-setting-up-xero"),
    xeroReactivateItems: ()=>helpArticle('11625123-how-to-restore-items-in-xero'),
    xeroChangeInvoicePrefix: ()=>helpArticle('11640349-changing-invoice-prefix'),
    xeroCreationLocked: ()=>helpArticle('10205126-how-to-resolve-a-xero-sync-error-for-account-period-is-locked'),
    xeroContactMapping: ()=>helpArticle('11624549-setting-up-xero#h_45e0b58794'),
    xeroServicesMapping: ()=>helpArticle('11624549-setting-up-xero#h_788bc6aa6c'),
    salesTaxMapping: ()=>helpArticle('16861982-sales-tax'),
    bundles: ()=>helpArticle('12290730-bundles'),
    bulkCsvAiGuide: ()=>helpArticle('17280362-prepare-your-bulk-send-with-the-claude-connector')
};
